module.exports = __webpack_public_path__ + "img/title.e529d34b.png";